import { Loading } from '@affine/component/ui/loading';
import type { ReactNode } from 'react';

import * as styles from './online-search-footer.css';

export interface OnlineSearchFooterProps {
  label: ReactNode;
  /** Set: a button that lists the held server hits. Unset: a note. */
  onClick?: () => void;
  busy?: boolean;
}

/** The online part of a cloud search under the results: count, button or state. */
export const OnlineSearchFooter = ({
  label,
  onClick,
  busy,
}: OnlineSearchFooterProps) =>
  onClick ? (
    <button
      type="button"
      className={styles.action}
      onClick={onClick}
      data-testid="quick-search-online-more"
    >
      {label}
    </button>
  ) : (
    <span
      className={styles.note}
      aria-busy={busy || undefined}
      data-testid="quick-search-online-state"
    >
      {busy ? <Loading size={12} /> : null}
      {label}
    </span>
  );
